// import main module definition.
import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';

import '../../../css/placesList/realtimePlacelist.scss';
// react version
const gamesCarouselPageId = 'place-list';

ready(() => {
  if (document.getElementById(gamesCarouselPageId)) {
    render(<App />, document.getElementById(gamesCarouselPageId));
  }
});
